import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';
import CheckoutTermsConditions from 'components/FrictionlessCheckout/CheckoutTermsConditions/CheckoutTermsConditions';
import FrictionlessCheckoutTermsEN from 'components/FrictionlessCheckout/CheckoutTermsConditions/locales/ReviewText_en_US';
import FrictionlessCheckoutTermsFR from 'components/FrictionlessCheckout/CheckoutTermsConditions/locales/ReviewText_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(FrictionlessCheckoutTermsEN, FrictionlessCheckoutTermsFR);
const localization = createStructuredSelector({
    pleaseReviewOrderInfoText: getTextFromResource(getText, 'pleaseReviewOrderInfoText'),
    byPlacingOrderCaText: getTextFromResource(getText, 'byPlacingOrderCaText'),
    termsOfPurchase: getTextFromResource(getText, 'termsOfPurchase'),
    termsOfUse: getTextFromResource(getText, 'termsOfUse'),
    privacyPolicy: getTextFromResource(getText, 'privacyPolicy'),
    andText: getTextFromResource(getText, 'andText')
});

const fields = createStructuredSelector({
    localization
});

const withComponentProps = wrapHOC(connect(fields, null));

export default withComponentProps(CheckoutTermsConditions);
